import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from '@ashvin27/react-datatable';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import UserAddModal from "../partials/UserAddModal";
import UserUpdateModal from "../partials/UserUpdateModal";
import { toast } from "react-toastify";

class Users extends Component {

    constructor(props) {
        super(props);

        this.columns = [
            {
                key: "_id",
                text: "Id",
                className: "id",
                align: "left",
                sortable: true,
            },
            {
                key: "name",
                text: "Name",
                className: "name",
                align: "left",
                sortable: true,
            },
            {
                key: "email",
                text: "Email",
                className: "email",
                align: "left",
                sortable: true
            },
            {
                key: "status",
                text: "Status",
                className: "status",
                align: "left",
                sortable: true,
                cell: record => {
                    return (
                        <span className={record.status === 1 ? "badge badge-success" : "badge badge-danger"}>
                            {record.status === 1 ? "Active" : "Inactive"}
                        </span>
                    );
                }
            },
            {
                key: "date",
                text: "Date",
                className: "date",
                align: "left",
                sortable: true,
                cell: record => {
                    return (
                        <span>{new Date(record?.date).toDateString()}</span>
                    );
                }
            },
            {
                key: "action",
                text: "Action",
                className: "action",
                width: 100,
                align: "left",
                sortable: false,
                cell: record => {
                    return (
                        <Fragment>
                            <button
                                data-toggle="modal"
                                data-target="#update-user-modal"
                                className="btn btn-primary btn-sm"
                                onClick={() => this.editRecord(record)}
                                style={{ marginRight: '5px' }}>
                                <i className="fa fa-edit"></i>
                            </button>
                            <button
                                className="btn btn-danger btn-sm"
                                onClick={() => this.deleteRecord(record)}>
                                <i className="fa fa-trash"></i>
                            </button>
                        </Fragment>
                    );
                }
            }
        ];

        this.config = {
            page_size: 20,
            length_menu: [20, 30, 50],
            filename: "Users",
            no_data_text: 'No user found!',
            button: {
                excel: true,
                print: true,
                csv: true
            },
            language: {
                length_menu: "Show _MENU_ result per page",
                filter: "Filter in records...",
                info: "Showing _START_ to _END_ of _TOTAL_ records",
                pagination: {
                    first: "First",
                    previous: "Previous",
                    next: "Next",
                    last: "Last"
                }
            },
            show_length_menu: true,
            show_filter: true,
            show_pagination: true,
            show_info: true,
        };

        this.state = {
            records: [],
            currentRecord: {},
            showInactive: false,
        };

        this.state = {
            currentRecord: {
                id: '',
                name: '',
                email: '',
                password: '',
                password2: '',
            }
        };

        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        this.getData()
    };

    componentWillReceiveProps(nextProps) {
        this.getData()
    }

    getData() {
        axios
            .get(`/api/user-data?showInactive=${this.state.showInactive}`)
            .then(res => {
                this.setState({ records: res.data })
            })
            .catch()
    }

    editRecord(record) {
        this.setState({ currentRecord: record });
    }

    deleteRecord(record) {
        axios
            .post("/api/user-delete", { _id: record._id })
            .then(res => {
                if (res.status === 200) {
                    toast.success(res.data.message)
                    this.getData();
                }
            })
            .catch();
    }

    pageChange(pageData) {
        console.log("OnPageChange", pageData);
    }

    render() {
        return (
            <div>
                <Navbar />
                <div className="d-flex" id="wrapper">
                    <Sidebar />
                    <UserAddModal getData={this.getData} />
                    <UserUpdateModal record={this.state.currentRecord} getData={this.getData} />
                    <div id="page-content-wrapper">
                        <div className="container-fluid backdrop-cont px-2 mt-2">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <button
                                        className="btn btn-link"
                                        id="menu-toggle"
                                        onClick={() => {
                                            document.body.classList.toggle("sidebar-expanded");
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faList} />
                                    </button>
                                    <h5 className="text-primary mb-0 ms-2">Users List</h5>
                                </div>
                                <div>
                                    <button
                                        className="btn btn-sm btn-primary"
                                        onClick={() => {
                                            window.$('#add-user-modal').modal('show');
                                        }}
                                    >
                                        + Add User
                                    </button>
                                </div>
                            </div>

                            <div className="task-table">
                                <div className="user-table-checkbox">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        style={{ width: '17px', height: '17px' }}
                                        checked={this.state.showInactive}
                                        onChange={(e) => {
                                            this.setState({ showInactive: e.target.checked }, () => {
                                                this.getData();
                                            });
                                        }}
                                        id="showInactiveCheckbox"
                                    />
                                    <label className="form-check-label" htmlFor="showInactiveCheckbox">
                                        Show all users
                                    </label>
                                </div>
                                <ReactDatatable
                                    config={this.config}
                                    records={this.state.records}
                                    columns={this.columns}
                                    onPageChange={this.pageChange.bind(this)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

Users.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
    records: state.records
});

export default connect(
    mapStateToProps
)(Users);
